export enum ContactNewsletterState {
    SUBSCRIBER = 0,
    NONE = 1
}